








































import layout from '@/libs/layout/educational/student.ts';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  getCourseStudentPage,
  deleteCourseStudent,
  getQrcode
} from '@/api/educational';
import {
  PGetCourseStudentPage,
  TStudentPage,
  TStudentList
} from '@/types/views/educational';
import { TLayout } from '@/types/utils';
import { getCourseById } from '@/api/educational';
@Component({
  components: {
    Add: () => import('./add.vue')
  }
})
export default class Student extends Vue {
  @Prop({
    type: String,
    required: true
  })
  courseId!: string;
  @Prop({
    type: String,
    required: true
  })
  orgId!: string;
  @Watch('subOrgId')
  startGetCourse(newVal: any, oldVal: any) {
    console.log("执行了监听")
    this.searchOption = {
      ...this.searchOption,
      ...{ orgId: newVal, courseId: this.$route.params.id, lessonId: this.$route.params.id }
    };
    this.getStudenPage();
  }
  private layout: TLayout = layout;
  private qrcodeUrl = '';
  private page: TStudentPage = {
    currentPage: 1,
    pageSize: 20
  };
  private searchOption: PGetCourseStudentPage = {
    orgId: this.orgId,
    courseId: this.courseId,
    lessonId: '',
    currentPage: 1,
    pageSize: 20
  };
  private subOrgId = ''
  private mounted() {
    this.getCourseInfo()
  }
  private activated() {
    console.log("sss")
    this.searchOption = {
      ...this.searchOption,
      ...{ orgId: this.orgId, courseId: this.$route.params.id, lessonId: this.$route.params.id }
    };
    this.getStudenPage();
  }
  private handlePage(page: number) {
    this.searchOption = { ...this.searchOption, ...{ currentPage: page } };
    this.getStudenPage();
  }
  private handleSize(size: number) {
    this.searchOption = { ...this.searchOption, ...{ pageSize: size } };
    this.getStudenPage();
  }

  private renderIndex(index: number) {
    return index + 1 + (this.page.currentPage - 1) * this.page.pageSize || 0;
  }
  private async getStudenPage() {
    try {
      this.page = await getCourseStudentPage(this.searchOption);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async getStudentQrcode() {
    try {
      let res = await getQrcode({
        courseId: this.$route.params.id
      });
      this.qrcodeUrl = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private reload() {
    this.searchOption = {
      orgId: this.orgId,
      courseId: this.courseId,
      lessonId: this.$route.params.id,
      currentPage: 1,
      pageSize: 20
    };
    this.getStudenPage();
  }
  private async deleteStudent(v: TStudentList) {
    try {
      const data: any = await deleteCourseStudent({
        courseId: this.courseId,
        orgUserId: v.id
      });
      if (data.code === '000001') {
        this.$message.success('删除成功');
        this.reload();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private demo(v: TStudentList) {
    this.$confirm('您确定要删除该学员?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.deleteStudent(v);
        this.reload();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
  }
  private async getCourseInfo() {
    console.log("迫不得已执行一次")
    try {
      let res: any = await getCourseById({
        courseId: this.$route.params.id
      });

      this.subOrgId = String(res.orgId)
    } catch (e) {
      // this.$message.error(e.message);
    }
  }
}
